import script from "./AreaModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AreaModal.vue?vue&type=script&lang=ts&setup=true"

import "./AreaModal.vue?vue&type=style&index=0&id=4de544d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de544d8"]])

export default __exports__